/* Background Agent installers. Mirrors the host's DownloadAll.js:

     1. ask /api/v1/stealth-agent/downloads/<key> and follow its redirect —
        the backend presigns with its own credentials
     2. otherwise fall through to the API URL and let the server answer

   A third step used to live here: presign the S3 object in the browser when
   the API route wasn't available. That needed an AWS key pair in the bundle,
   so it was removed along with the credentials. The backend route has shipped,
   which is what step 1 uses.

   Keep in sync with the host's copy. */

const AGENT_BASE = '/api/v1/stealth-agent/downloads';

export async function resolveAgentDownloadUrl(key) {
  const apiUrl = `${AGENT_BASE}/${key}`;
  try {
    const res = await fetch(apiUrl, { method: 'GET', redirect: 'manual' });
    if (res.status === 301 || res.status === 302 || res.status === 303 || res.status === 307) {
      const loc = res.headers.get('Location');
      if (loc) return loc;
    }
    if (res.ok) return apiUrl;
  } catch {
    /* fall through — the browser will follow the API URL itself */
  }
  return apiUrl;
}

/** Trigger an agent download. Mirrors the host's dlAgent(). */
export async function startAgentDownload(key) {
  const href = await resolveAgentDownloadUrl(key);
  /* Deliberately NO a.download — a cross-origin S3 redirect with a download
     attribute makes Chrome fail with "file wasn't available". Same reason the
     host omits it. */
  const a = document.createElement('a');
  a.href = href;
  a.rel = 'noopener noreferrer';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/* Layman install guides (PDF) served from the frontend's public/guides folder. */
export const AGENT_GUIDE = {
  windows: '/guides/TeamGrid-Background-Agent-Windows.pdf',
  mac: '/guides/TeamGrid-Background-Agent-macOS.pdf',
  linux: '/guides/TeamGrid-Background-Agent-Linux.pdf',
};
